import React from 'react'
import parse from 'html-react-parser'


import IcAgreement from '../../assets/img/ic_agreement.svg'
import IcPriceYellow from '../../assets/img/ic_price_yellow.svg'

import { logEvent } from '../../Utils/utils'
import ButtonYapp from '../Buttons/ButtonYapp'
import { _formatPrice } from '../../Utils/tools'


function AgreementCard(props) {
  let productDiscount = props?.productDiscount

  return (
    <>
      <div className="content-yapp-agreement mb-4">
        <div className="header-yapp-agreement">
          <img src={IcAgreement} alt="" className="" />
          <h4 className="title-primary m-0 ml-2">
            {props?.subscriptionProProduct?.title}
          </h4>
        </div>
        <div className="container-yapp-agreement ">
          <div className="content-yapp-agreement-left mr-md-2">
            <div className="banner-discount mb-2">
              <p className="txt-paragraph--bold m-0">
                {productDiscount?.discount}
              </p>
              <p className="txt-line line-14 m-0">
                {props?.subscriptionProProduct.discountSubText}
              </p>
            </div>
            <div className='d-block d-md-none'>
              <div className='d-flex flex-column align-items-center justify-content-between pt-2 '>
                <img src={IcPriceYellow} alt='price' height='24' className='mb-1' />
                { productDiscount?.subscription_price &&
                  <div className='d-flex flex-column align-items-center align-items-center mrn-16-mobile'>
                    <h5 className='txt-5--regular-g1 m-0'> Precio inicial<span className='txt-line-through'>{_formatPrice(productDiscount.subscription_price)}</span></h5>
                    <p className='txt-4--bold-db '>Precio final {_formatPrice(productDiscount.subscription_price_with_discount)}</p>
                  </div>
                }
              </div>
            </div>
            <p className="txt-line line-14 m-0 mb-2 mb-md-0 pt-2">
              <span className='txt-5--regular text-center d-flex'>
                {/* {props?.subscriptionProProduct.content}*/}
                {/* props?.subscriptionProProduct.contentBol */}
                {parse(`Comparte este descuento con tus pacientes para que reciban su tratamiento al mejor precio a través de nuestra web y/o app.`)}
              </span>
            </p>
          </div>
          <div className="content-yapp-agreement-right">
            <div className='d-none d-md-block'>
              <div className='d-flex flex-column align-items-center justify-content-between pt-2 '>
                { productDiscount?.subscription_price &&
                  <div className='d-flex flex-column align-items-center align-items-center mrn-16'>
                    <img src={IcPriceYellow} alt='price' height='24' className='mb-1' />
                    <h5 className='txt-5--regular-g1 m-0'>Precio inicial <span className=' txt-5--regular-g1 txt-line-through'>{_formatPrice(productDiscount.subscription_price)}</span></h5>
                    <p className='txt-4--bold-db'>Precio final {_formatPrice(productDiscount.subscription_price_with_discount)}</p>
                  </div>
                }
              </div>
            </div>

            {/* <div className="yapp-agreement-copy-code">
              <div className="">
                <h4 className="txt-line--bold color-gray-4 m-0 mb-1">
                  {props?.subscriptionProProduct.label}
                </h4>
                <h4 className="txt-paragraph--bold m-0">
                  {props?.professionalDiscountCode}
                </h4>
              </div>
              <div
                className="d-flex align-items-center h-100 c-pointer"
                onClick={() => props.copyCodeToClipboard()}>
                <h6 className="txt-paragraph--bold color-lilac m-0">
                  Copiar
                </h6>
              </div>
            </div> */}
            <div className="content-yapp-agreement-share mt-2">
              <ButtonYapp
                className="btn-share-send-email mt-md-2"
                onClick={() => {
                  console.table(props?.professionalDiscountCode, props?.appState?.data?.laboratory_name, props?.productId, props?.appState?.data?.product_name, props?.contactLaboratory)
                  logEvent('Item Share Opened', {
                    'Shared Type': 'Yapp Benefit Code',
                    'Element Shared': props?.professionalDiscountCode,
                    'Lab Name': props?.appState?.data?.laboratory_name,
                    'Product Id': props?.productId,
                    'Product Name': props?.appState?.data?.product_name,
                    'Lab Id': props?.contactLaboratory?.laboratory_id,
                    // 'Shared': null,
                    // 'Active Principle Id': null,
                    // 'Active Principle Name': null,
                    // 'Category Id': null,
                    // 'Category Name': null,
                  })
                  props?.setSendDiscountIsOpen(true)
                }}
                title={props?.subscriptionProProduct.btnText}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AgreementCard
